import { useEffect, useState } from "react";
import {
  useGetFiletTasksQuery,
  useGetProjectsQuery,
} from "../../features/api/apiSlice";

const Projects = () => {
  const { data: projects, isLoading, isError, error } = useGetProjectsQuery();

  const [checkbox, setCheckbox] = useState([]);
  const [filterBy, setFilterBy] = useState("");

  const { data: tasks } = useGetFiletTasksQuery(filterBy, {
    refetchOnMountOrArgChange: true,
  });

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      setCheckbox([...checkbox, name]);
    } else {
      setCheckbox((prev) => prev.filter((itm) => itm !== name));
    }
  };

  useEffect(() => {
    if (!isLoading) {
      const projectName = projects?.map((p) => p.projectName);
      setCheckbox([...projectName]);
    }
  }, [projects, isLoading]);

  useEffect(() => {
    if (!isLoading) {
      const customSearch = checkbox
        ?.map((c) => `project.projectName=${c}`)
        .join("&");

      setFilterBy(customSearch);
    }
  }, [checkbox, isLoading]);

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <p>Loading...</p>;
  } else if (!isLoading && isError) {
    content = <p>{error?.data}</p>;
  } else if (!isLoading && !isError && projects?.length === 0) {
    content = <p>No Projects found!</p>;
  } else if (!isLoading && !isError && projects?.length > 0) {
    content = projects.map((project) => (
      <div className="checkbox-container" key={project.id}>
        <input
          type="checkbox"
          className={project.colorClass}
          name={project.projectName}
          checked={checkbox.includes(project.projectName)}
          onChange={handleCheckbox}
        />
        <p className="label">{project.projectName}</p>
      </div>
    ));
  }

  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
};

export default Projects;
